import {PubSub} from '@mamdev/cad.static-next-lib';
import Validation from '../../ts/services/validation';

class TrackerObject {
  [key: string]: string;
}

const defaultPixelParams = {
  referrer: 'undefined',
  click1: 'undefined',
  click2: 'undefined',
  click3: 'undefined',
  click4: 'undefined'
};

const topicName = 'tracker:sendEventPixel';

function prepareObj_(srcObj: TrackerObject) {
  const ret = new TrackerObject();
  for (const prop in srcObj) {
    if (Validation.hasProperty(srcObj, prop)) {
      ret[prop] = `&${prop}=${srcObj[prop]}`;
    }
  }
  return ret;
}

/**
 * Tracker service to simplify tracking
 */
export class Tracker {
  private static readonly topicName_ = 'tracker:sendEventPixel';

  /**
   * Prepares a pixel object with a specific click name and optional parameters.
   * Fires an event so that the analytics service can fire the actual pixel.
   * @param {string} clickName
   * @param {object} [params] Optional additional parameters
   */
  static sendPixel(clickName: string, params = {}) {
    const px = {...defaultPixelParams, 'clickname': clickName, ...params};
    PubSub.publish(topicName, px);
  }

  /**
   * sendPixelEx
   */
  static sendPixelEx(pixelObj: object) {
    const px = {...defaultPixelParams, ...prepareObj_(pixelObj as TrackerObject)};
    PubSub.publish(this.topicName_, px);
  }
}
